import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { EmployeesService } from 'src/app/shared/services/employees/employees.service';
import { ImportService } from 'src/app/shared/services/payroll/import.service';

@Component({
  selector: 'contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class EnrollmentContactInfoComponent implements OnInit {
  identifierMask = 'LLLLLLLLLLLLL';
  rules: { [key: string]: RegExp } = {
    'L': /^[a-zA-Z0-9]+$/
  };
  phoneMask = '000-000-0000';
  states: any;
  value: any;
  phoneValue: any;
  summaryData: any;
  config: any;
  proofofBirthOptions: any;
  displayload: boolean;
  isIdentifireVisible: boolean;
  isFileInvalid = false;
  isOldRecord: boolean;
  isUploadFileExist: boolean;
  fileUploadData = [];
  zipMask = '00000';
  zip4Mask = '0000';
  contactInfoForm: FormGroup;
  speCharPattern = /^[a-zA-Z\s.'\-,`]+$/;
  defaultProofofBirth: { name: string; id: string } = {
    name: 'Select...',
    id: ''
  };
  defaultState: { name: string; abbreviation: string } = {
    name: 'Select...',
    abbreviation: ''
  }
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".pdf", ".tif", ".tiff", ".png", ".docx", ".doc"]
  };
  @Output() goTo = new EventEmitter<object>();

  @Input() set personInfo(wizardData: any) {
    if (wizardData) {
      this.summaryData = wizardData;
      if (wizardData.isContactInfo) {
        this.setContactInfo(this.summaryData.wizardData);
      }
    }
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private importService: ImportService,
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) {
    this.config = this.readConfigService.getEnrollmentMemberText();
  }

  ngOnInit(): void {
    this.newForm();
    this.loadStates();
  }

  loadStates() {
    this.importService.getStates(false)
      .subscribe(states => {
        this.states = states;
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setErrorNotification();
        });
  }

  newForm() {
    this.contactInfoForm = this.fb.group({
      proofOfBirthType: ['', Validators.required],
      customerIdentifierNo: [''],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', [Validators.required, Validators.pattern(this.speCharPattern)]],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      zip4: [''],
      phoneNo: ['', Validators.required],
      workEmail: ['', [Validators.required, Validators.maxLength(200), Validators.email]],
      personalEmail: ['', [Validators.maxLength(200), Validators.email]]
    });
  }

  setContactInfo(data: any) {
    this.isUploadFileExist = data.contactDetails ? (data.contactDetails.uploadedFileName !== null && data.contactDetails.uploadedFile !== null) : false;
    if (data.contactDetails) {
      this.isOldRecord = true;
      const contactInfo = data.contactDetails;
      this.newForm();
      this.isIdentifireVisible
      const proofType = this.config.ProofofBirthOptions.filter(ele => ele.name.toLowerCase() === contactInfo.proofOfBirthType.toLowerCase());
      this.selectionChange(proofType[0]);
      setTimeout(() => {
        this.contactInfoForm.patchValue({
          proofOfBirthType: proofType[0].id,
          customerIdentifierNo: contactInfo.customerIdentifierNo,
          addressLine1: contactInfo.addressLine1,
          addressLine2: contactInfo.addressLine2,
          city: contactInfo.city,
          state: contactInfo.state,
          zip: contactInfo.zip,
          zip4: contactInfo.zip4,
          phoneNo: contactInfo.phoneNo,
          personalEmail: contactInfo.personalEmail,
          workEmail: contactInfo.workEmail
        });
      }, 100);
    }
  }

  selectionChange(value: any) {
    if (value.id.toString() === '1') {
      this.isIdentifireVisible = true;
      this.contactInfoForm.controls.customerIdentifierNo.setValidators([Validators.required]);
    } else {
      this.isIdentifireVisible = false;
      this.contactInfoForm.get('customerIdentifierNo').setValidators(null);
      this.contactInfoForm.patchValue({ customerIdentifierNo: '' });
    }
  }

  onSelectEvent(e: SelectEvent) {
    if (e && e.files && e.files.length > 0) {
      if (e.files[0]?.validationErrors?.length > 0) {
        this.isFileInvalid = true;
      } else {
        this.fileUploadData = e.files;
        this.isFileInvalid = false;
      }
    }
  }

  onRemoveEvent(e: any) {
    this.fileUploadData = [];
  }

  goToPreviousPage(option: number) {
    this.previous(option);
  }

  previous(option: number) {
    this.goTo.emit({
      option, isEnrollmentInfo: true, wizardData: {
        personDetails: this.summaryData.wizardData.personDetails, ssn: this.summaryData.wizardData.ssn,
        empSSN: this.summaryData.wizardData.empSSN, enrollmentsId: this.summaryData.wizardData.enrollmentsId,
        enrollmentDetails: this.summaryData.wizardData.enrollmentDetails, contactDetails: this.summaryData.wizardData.contactDetails
      }
    });
  }

  submitBtnDisable() {
    return this.contactInfoForm.invalid
      || (this.isUploadFileExist ? false : this.fileUploadData.length === 0)
      || (this.isUploadFileExist ? false : this.isFileInvalid)
  }

  downloadUploadedFile(data: any) {
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      id: data.wizardData.contactDetails.id,
      type: 'contact',
      fileName: data.wizardData.contactDetails.uploadedFileName
    };
    this.employeesService.downloadUploadedFile(inputData).subscribe(() => {
      data.docClicked = !data.docClicked;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        data.docClicked = !data.docClicked;
      });
  }

  submitContactData(option: number) {
    this.displayload = true;
    const proofType = this.config.ProofofBirthOptions.filter(ele => ele.id === this.contactInfoForm.getRawValue().proofOfBirthType);
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      contactInfo: {
        id: this.isOldRecord ? this.summaryData.wizardData.contactDetails.id : 0,
        enrollmentsId: this.summaryData.wizardData.enrollmentsId,
        proofOfBirthType: proofType[0].name,
        customerIdentifierNo: this.contactInfoForm.getRawValue().customerIdentifierNo,
        addressLine1: this.contactInfoForm.getRawValue().addressLine1,
        addressLine2: this.contactInfoForm.getRawValue().addressLine2,
        city: this.contactInfoForm.getRawValue().city,
        state: this.contactInfoForm.getRawValue().state,
        zip: this.contactInfoForm.getRawValue().zip,
        zip4: this.contactInfoForm.getRawValue().zip4,
        phoneNo: this.contactInfoForm.getRawValue().phoneNo,
        personalEmail: this.contactInfoForm.getRawValue().personalEmail,
        workEmail: this.contactInfoForm.getRawValue().workEmail
      },
      uploadedFile: this.fileUploadData[0],
      fileName: this.fileUploadData[0] ? null : this.summaryData.wizardData.contactDetails.uploadedFileName
    }
    this.employeesService.saveContactInfo(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.notificationService.setUpNotification({ message: response.message, success: true });
        this.goTo.emit({
          option, isFinalSubmit: true
        });
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else if (response && response.statusCode === 400) {
        this.notificationService.setUpNotification({ message: response.message, success: false });
      } else {
        this.notificationService.setErrorNotification();
      }
      this.displayload = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.displayload = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

}
